"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FIRST_PAGE = exports.FILTER_OUTLINE = exports.FAVOURITE_OUTLINE = exports.FAVOURITE = exports.EMOJI = exports.EMAIL = exports.EDIT = exports.DROPDOWN_OUTLINE = exports.DROPDOWN = exports.DOWNLOAD = exports.DOCUMENT = exports.DEVELOPER = exports.DETAILS = exports.DESCRIPTION = exports.DELETE = exports.CUSTOMIZE = exports.CUSTOMER = exports.CREDIT_CHECK = exports.COPY = exports.COLOR_PICKER = exports.COLLAPSE = exports.CODEBLOCK = exports.CLOSE_OUTLINE = exports.CLOSE = exports.CHAT = exports.CANCEL_INVITATION = exports.CAMPAIGN = exports.CAMERA = exports.CALL = exports.CALENDAR = exports.BUSINESS_UNIT = exports.BULLET_POINT = exports.BOOKING_SETUP = exports.BOOKING_FORM = exports.BOOKING = exports.BOLD = exports.BLOCKQUOTE = exports.BANKER = exports.BACK = exports.ATTACH = exports.ALIGN_RIGHT = exports.ALIGN_MIDDLE = exports.ALIGN_LEFT = exports.AGENT = exports.ADMIN = exports.ADD_USER = exports.ADD_CIRCLE = exports.ADD = exports.ACTIVITY_LOG = exports.ACTION = exports.USER_GUIDE = exports.USER = exports.UPLOAD = exports.UPGRADE = exports.UNIT_SETUP = exports.UNDO = exports.UNDERLINE = exports.TIME = exports.TICK = exports.STRIKETHROUGH = exports.STATUS = exports.STAFF = exports.SPA = exports.SORT_BY_OUTLINE = exports.SMS = exports.SHOWROOM = exports.SHARE = exports.SETUP = exports.SEND = exports.SEARCH_OUTLINE = exports.SCHEDULE = exports.SAVE = exports.ROTATE_CLOCKWISE = exports.ROTATE_ANTI_CLOCKWISE = exports.REVEAL = exports.REMOVE = exports.REMARK = exports.REDO = exports.REASSIGN = exports.RE_INVITE = exports.PROSPECT = exports.PROJECT = exports.PRINT = exports.PREVIEW = exports.POST_SALES = exports.PERFORMANCE = exports.PAYMENT = exports.ORDERED_LIST = exports.NUDGE = exports.NOTIFICATION_OUTLINE = exports.NOTIFICATION = exports.NEXT = exports.MOVE = exports.MORE_INFORMATION = exports.MONOSPACE = exports.MINIMIZE = exports.MILESTONE = exports.ZOOM_OUT = exports.ZOOM_IN = exports.VIEW = void 0;
exports.ICON_NAMES = exports.MENU = exports.MARKETPLACE = exports.MANAGE = exports.MAIL_LIST = exports.LOG_OUT = exports.LOCK = exports.LOCATION = exports.LOAN_TRACKER = exports.LOAN_CALCULATOR = exports.LOADING = exports.LINK = exports.LEADS = exports.LAWYER = exports.LAST_PAGE = exports.JUSTIFY = exports.ITALIC = exports.HOME = exports.HIGHLIGHT = exports.HIDE = exports.HEADING_6 = exports.HEADING_5 = exports.HEADING_4 = exports.HEADING_3 = exports.HEADING_2 = exports.HEADING_1 = exports.GO = exports.FORM = exports.FONT_COLOR = exports.FIT_TO_SCREEN = void 0;
var VIEW = 'view';
exports.VIEW = VIEW;
var ZOOM_IN = 'zoom_in';
exports.ZOOM_IN = ZOOM_IN;
var ZOOM_OUT = 'zoom_out';
exports.ZOOM_OUT = ZOOM_OUT;
var MILESTONE = 'milestone';
exports.MILESTONE = MILESTONE;
var MINIMIZE = 'minimize';
exports.MINIMIZE = MINIMIZE;
var MONOSPACE = 'monospace';
exports.MONOSPACE = MONOSPACE;
var MORE_INFORMATION = 'more_information';
exports.MORE_INFORMATION = MORE_INFORMATION;
var MOVE = 'move';
exports.MOVE = MOVE;
var NEXT = 'next';
exports.NEXT = NEXT;
var NOTIFICATION = 'notification';
exports.NOTIFICATION = NOTIFICATION;
var NOTIFICATION_OUTLINE = 'notification_outline';
exports.NOTIFICATION_OUTLINE = NOTIFICATION_OUTLINE;
var NUDGE = 'nudge';
exports.NUDGE = NUDGE;
var ORDERED_LIST = 'ordered_list';
exports.ORDERED_LIST = ORDERED_LIST;
var PAYMENT = 'payment';
exports.PAYMENT = PAYMENT;
var PERFORMANCE = 'performance';
exports.PERFORMANCE = PERFORMANCE;
var POST_SALES = 'post_sales';
exports.POST_SALES = POST_SALES;
var PREVIEW = 'preview';
exports.PREVIEW = PREVIEW;
var PRINT = 'print';
exports.PRINT = PRINT;
var PROJECT = 'project';
exports.PROJECT = PROJECT;
var PROSPECT = 'prospect';
exports.PROSPECT = PROSPECT;
var RE_INVITE = 're_invite';
exports.RE_INVITE = RE_INVITE;
var REASSIGN = 'reassign';
exports.REASSIGN = REASSIGN;
var REDO = 'redo';
exports.REDO = REDO;
var REMARK = 'remark';
exports.REMARK = REMARK;
var REMOVE = 'remove';
exports.REMOVE = REMOVE;
var REVEAL = 'reveal';
exports.REVEAL = REVEAL;
var ROTATE_ANTI_CLOCKWISE = 'rotate_anti_clockwise';
exports.ROTATE_ANTI_CLOCKWISE = ROTATE_ANTI_CLOCKWISE;
var ROTATE_CLOCKWISE = 'rotate_clockwise';
exports.ROTATE_CLOCKWISE = ROTATE_CLOCKWISE;
var SAVE = 'save';
exports.SAVE = SAVE;
var SCHEDULE = 'schedule';
exports.SCHEDULE = SCHEDULE;
var SEARCH_OUTLINE = 'search_outline';
exports.SEARCH_OUTLINE = SEARCH_OUTLINE;
var SEND = 'send';
exports.SEND = SEND;
var SETUP = 'setup';
exports.SETUP = SETUP;
var SHARE = 'share';
exports.SHARE = SHARE;
var SHOWROOM = 'showroom';
exports.SHOWROOM = SHOWROOM;
var SMS = 'sms';
exports.SMS = SMS;
var SORT_BY_OUTLINE = 'sort_by_outline';
exports.SORT_BY_OUTLINE = SORT_BY_OUTLINE;
var SPA = 'spa';
exports.SPA = SPA;
var STAFF = 'staff';
exports.STAFF = STAFF;
var STATUS = 'status';
exports.STATUS = STATUS;
var STRIKETHROUGH = 'strikethrough';
exports.STRIKETHROUGH = STRIKETHROUGH;
var TICK = 'tick';
exports.TICK = TICK;
var TIME = 'time';
exports.TIME = TIME;
var UNDERLINE = 'underline';
exports.UNDERLINE = UNDERLINE;
var UNDO = 'undo';
exports.UNDO = UNDO;
var UNIT_SETUP = 'unit_setup';
exports.UNIT_SETUP = UNIT_SETUP;
var UPGRADE = 'upgrade';
exports.UPGRADE = UPGRADE;
var UPLOAD = 'upload';
exports.UPLOAD = UPLOAD;
var USER = 'user';
exports.USER = USER;
var USER_GUIDE = 'user_guide';
exports.USER_GUIDE = USER_GUIDE;
var ACTION = 'action';
exports.ACTION = ACTION;
var ACTIVITY_LOG = 'activity_log';
exports.ACTIVITY_LOG = ACTIVITY_LOG;
var ADD = 'add';
exports.ADD = ADD;
var ADD_CIRCLE = 'add_circle';
exports.ADD_CIRCLE = ADD_CIRCLE;
var ADD_USER = 'add_user';
exports.ADD_USER = ADD_USER;
var ADMIN = 'admin';
exports.ADMIN = ADMIN;
var AGENT = 'agent';
exports.AGENT = AGENT;
var ALIGN_LEFT = 'align_left';
exports.ALIGN_LEFT = ALIGN_LEFT;
var ALIGN_MIDDLE = 'align_middle';
exports.ALIGN_MIDDLE = ALIGN_MIDDLE;
var ALIGN_RIGHT = 'align_right';
exports.ALIGN_RIGHT = ALIGN_RIGHT;
var ATTACH = 'attach';
exports.ATTACH = ATTACH;
var BACK = 'back';
exports.BACK = BACK;
var BANKER = 'banker';
exports.BANKER = BANKER;
var BLOCKQUOTE = 'blockquote';
exports.BLOCKQUOTE = BLOCKQUOTE;
var BOLD = 'bold';
exports.BOLD = BOLD;
var BOOKING = 'booking';
exports.BOOKING = BOOKING;
var BOOKING_FORM = 'booking_form';
exports.BOOKING_FORM = BOOKING_FORM;
var BOOKING_SETUP = 'booking_setup';
exports.BOOKING_SETUP = BOOKING_SETUP;
var BULLET_POINT = 'bullet_point';
exports.BULLET_POINT = BULLET_POINT;
var BUSINESS_UNIT = 'business_unit';
exports.BUSINESS_UNIT = BUSINESS_UNIT;
var CALENDAR = 'calendar';
exports.CALENDAR = CALENDAR;
var CALL = 'call';
exports.CALL = CALL;
var CAMERA = 'camera';
exports.CAMERA = CAMERA;
var CAMPAIGN = 'campaign';
exports.CAMPAIGN = CAMPAIGN;
var CANCEL_INVITATION = 'cancel_invitation';
exports.CANCEL_INVITATION = CANCEL_INVITATION;
var CHAT = 'chat';
exports.CHAT = CHAT;
var CLOSE = 'close';
exports.CLOSE = CLOSE;
var CLOSE_OUTLINE = 'close_outline';
exports.CLOSE_OUTLINE = CLOSE_OUTLINE;
var CODEBLOCK = 'codeblock';
exports.CODEBLOCK = CODEBLOCK;
var COLLAPSE = 'collapse';
exports.COLLAPSE = COLLAPSE;
var COLOR_PICKER = 'color_picker';
exports.COLOR_PICKER = COLOR_PICKER;
var COPY = 'copy';
exports.COPY = COPY;
var CREDIT_CHECK = 'credit_check';
exports.CREDIT_CHECK = CREDIT_CHECK;
var CUSTOMER = 'customer';
exports.CUSTOMER = CUSTOMER;
var CUSTOMIZE = 'customize';
exports.CUSTOMIZE = CUSTOMIZE;
var DELETE = 'delete';
exports.DELETE = DELETE;
var DESCRIPTION = 'description';
exports.DESCRIPTION = DESCRIPTION;
var DETAILS = 'details';
exports.DETAILS = DETAILS;
var DEVELOPER = 'developer';
exports.DEVELOPER = DEVELOPER;
var DOCUMENT = 'document';
exports.DOCUMENT = DOCUMENT;
var DOWNLOAD = 'download';
exports.DOWNLOAD = DOWNLOAD;
var DROPDOWN = 'dropdown';
exports.DROPDOWN = DROPDOWN;
var DROPDOWN_OUTLINE = 'dropdown_outline';
exports.DROPDOWN_OUTLINE = DROPDOWN_OUTLINE;
var EDIT = 'edit';
exports.EDIT = EDIT;
var EMAIL = 'email';
exports.EMAIL = EMAIL;
var EMOJI = 'emoji';
exports.EMOJI = EMOJI;
var FAVOURITE = 'favourite';
exports.FAVOURITE = FAVOURITE;
var FAVOURITE_OUTLINE = 'favourite_outline';
exports.FAVOURITE_OUTLINE = FAVOURITE_OUTLINE;
var FILTER_OUTLINE = 'filter_outline';
exports.FILTER_OUTLINE = FILTER_OUTLINE;
var FIRST_PAGE = 'first_page';
exports.FIRST_PAGE = FIRST_PAGE;
var FIT_TO_SCREEN = 'fit_to_screen';
exports.FIT_TO_SCREEN = FIT_TO_SCREEN;
var FONT_COLOR = 'font_color';
exports.FONT_COLOR = FONT_COLOR;
var FORM = 'form';
exports.FORM = FORM;
var GO = 'go';
exports.GO = GO;
var HEADING_1 = 'heading_1';
exports.HEADING_1 = HEADING_1;
var HEADING_2 = 'heading_2';
exports.HEADING_2 = HEADING_2;
var HEADING_3 = 'heading_3';
exports.HEADING_3 = HEADING_3;
var HEADING_4 = 'heading_4';
exports.HEADING_4 = HEADING_4;
var HEADING_5 = 'heading_5';
exports.HEADING_5 = HEADING_5;
var HEADING_6 = 'heading_6';
exports.HEADING_6 = HEADING_6;
var HIDE = 'hide';
exports.HIDE = HIDE;
var HIGHLIGHT = 'highlight';
exports.HIGHLIGHT = HIGHLIGHT;
var HOME = 'home';
exports.HOME = HOME;
var ITALIC = 'italic';
exports.ITALIC = ITALIC;
var JUSTIFY = 'justify';
exports.JUSTIFY = JUSTIFY;
var LAST_PAGE = 'last_page';
exports.LAST_PAGE = LAST_PAGE;
var LAWYER = 'lawyer';
exports.LAWYER = LAWYER;
var LEADS = 'leads';
exports.LEADS = LEADS;
var LINK = 'link';
exports.LINK = LINK;
var LOADING = 'loading';
exports.LOADING = LOADING;
var LOAN_CALCULATOR = 'loan_calculator';
exports.LOAN_CALCULATOR = LOAN_CALCULATOR;
var LOAN_TRACKER = 'loan_tracker';
exports.LOAN_TRACKER = LOAN_TRACKER;
var LOCATION = 'location';
exports.LOCATION = LOCATION;
var LOCK = 'lock';
exports.LOCK = LOCK;
var LOG_OUT = 'log_out';
exports.LOG_OUT = LOG_OUT;
var MAIL_LIST = 'mail_list';
exports.MAIL_LIST = MAIL_LIST;
var MANAGE = 'manage';
exports.MANAGE = MANAGE;
var MARKETPLACE = 'marketplace';
exports.MARKETPLACE = MARKETPLACE;
var MENU = 'menu';
exports.MENU = MENU;
var ICON_NAMES = [VIEW, ZOOM_IN, ZOOM_OUT, MILESTONE, MINIMIZE, MONOSPACE, MORE_INFORMATION, MOVE, NEXT, NOTIFICATION, NOTIFICATION_OUTLINE, NUDGE, ORDERED_LIST, PAYMENT, PERFORMANCE, POST_SALES, PREVIEW, PRINT, PROJECT, PROSPECT, RE_INVITE, REASSIGN, REDO, REMARK, REMOVE, REVEAL, ROTATE_ANTI_CLOCKWISE, ROTATE_CLOCKWISE, SAVE, SCHEDULE, SEARCH_OUTLINE, SEND, SETUP, SHARE, SHOWROOM, SMS, SORT_BY_OUTLINE, SPA, STAFF, STATUS, STRIKETHROUGH, TICK, TIME, UNDERLINE, UNDO, UNIT_SETUP, UPGRADE, UPLOAD, USER, USER_GUIDE, ACTION, ACTIVITY_LOG, ADD, ADD_CIRCLE, ADD_USER, ADMIN, AGENT, ALIGN_LEFT, ALIGN_MIDDLE, ALIGN_RIGHT, ATTACH, BACK, BANKER, BLOCKQUOTE, BOLD, BOOKING, BOOKING_FORM, BOOKING_SETUP, BULLET_POINT, BUSINESS_UNIT, CALENDAR, CALL, CAMERA, CAMPAIGN, CANCEL_INVITATION, CHAT, CLOSE, CLOSE_OUTLINE, CODEBLOCK, COLLAPSE, COLOR_PICKER, COPY, CREDIT_CHECK, CUSTOMER, CUSTOMIZE, DELETE, DESCRIPTION, DETAILS, DEVELOPER, DOCUMENT, DOWNLOAD, DROPDOWN, DROPDOWN_OUTLINE, EDIT, EMAIL, EMOJI, FAVOURITE, FAVOURITE_OUTLINE, FILTER_OUTLINE, FIRST_PAGE, FIT_TO_SCREEN, FONT_COLOR, FORM, GO, HEADING_1, HEADING_2, HEADING_3, HEADING_4, HEADING_5, HEADING_6, HIDE, HIGHLIGHT, HOME, ITALIC, JUSTIFY, LAST_PAGE, LAWYER, LEADS, LINK, LOADING, LOAN_CALCULATOR, LOAN_TRACKER, LOCATION, LOCK, LOG_OUT, MAIL_LIST, MANAGE, MARKETPLACE, MENU]; // v1.8
// Last generated at Tue, 16 Apr 2019 02:12:46 GMT

exports.ICON_NAMES = ICON_NAMES;